// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2wbEq","emails":"CreateEditClinics_emails__16b1v","emailTagLabel":"CreateEditClinics_emailTagLabel__3ATpo"};